var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.transformedAvatarImage,"alt":"Avatar image"}}):_c('i',{staticClass:"fa-solid fa-user fa-lg normal avatar avatar-dummy"})}
var staticRenderFns = []

export { render, staticRenderFns }